import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import domElements from './domElements';

// https://material-ui.com/customization/css-in-js/#styled-components-api-15-lines-
function styled(Component) {
  return (style, options) => {
    function StyledComponent(props) {
      const { classes, className, ...other } = props;
      return <Component className={classNames(classes.root, className)} {...other} />;
    }
    StyledComponent.propTypes = {
      classes: PropTypes.objectOf(PropTypes.string).isRequired,
      className: PropTypes.string,
    };
    StyledComponent.defaultProps = {
      className: '',
    };
    const styles =
      typeof style === 'function' ? theme => ({ root: style(theme) }) : { root: style };
    return withStyles(styles, options)(StyledComponent);
  };
}

// Shorthands for all valid HTML Elements
domElements.forEach(domElement => {
  styled[domElement] = styled(domElement);
});

export default styled;
